<template>
    <div class="did-container">
        <div class="search-container">
            <div class="row my-1">
                <search-input
                        class="search-input col-md-auto col-12 px-0  input-button-margin-size"
                        type="text"
                        v-model.trim="SearchDid"
                        placeholder="Search for DID"
                />
                <search-input
                        class="search-input col-md-auto col-12 px-0 input-button-margin-size"
                        v-model.trim="SearchCompany"
                        type="text"
                        placeholder="Search for Company"
                />
                <search-input
                        class="search-input col-md-auto col-12 px-0 input-button-margin-size"
                        v-model.trim="SearchVendor"
                        debounce="1000"
                        type="text"
                        placeholder="Search for Vendor"
                />
            </div>
            <div class="buttons-wrapper nav my-1">
                <primary-button
                        @click.native="$router.push({ name: 'system-admin-dids-import-log' })"
                        class="secondary-button importDid w-sm-auto w-100  mx-0 mx-sm-1 input-button-margin-size"
                >Import Log
                </primary-button
                >
                <primary-button
                        @click.native="$router.push({ name: 'system-admin-dids-import-did' })"
                        class="secondary-button importDid w-sm-auto w-100  mx-0 mx-sm-1 input-button-margin-size"
                >Import DID
                </primary-button
                >
                <primary-button @click.native="addDid()"
                                class="secondary-button addDid w-sm-auto w-100  mx-0 mx-sm-1 input-button-margin-size"
                >Add DID
                </primary-button
                >
                <primary-button
                        @click.native="deleteSelected()"
                        class="secondary-button deleteSelected w-sm-auto w-100  mx-0 mx-sm-1 input-button-margin-size"
                        :disabled="isDisabled"
                >Delete Selected
                </primary-button
                >
            </div>
        </div>
        <loader :loading="loading" v-if="loading"/>
        <template v-else>
            <div v-if="!dids.length && is_adding" class="no-data-found">No Data Found</div>
            <div
                    class="table_div"
                    style="width: 100%; overflow-x: auto; overflow-y: hidden"
                    v-else
            >
                <table class="Invoice_table">
                    <thead>
                    <tr class="Invoice_table_header">
                        <th class="equal-th">
                            <img
                                    v-if="isAllActive"
                                    class="number-icon"
                                    @click="allActive(true)"
                                    src="@/assets/Icon/Check/Active.svg"
                                    alt
                            />
                            <img
                                    v-if="!isAllActive"
                                    class="number-icon"
                                    @click="allActive(false)"
                                    src="@/assets/Icon/Check/Default.svg"
                            />Number
                            <span v-on:click="sorting('up', 'did')" class="sorting"
                            >&#8593;</span
                            >
                            <span v-on:click="sorting('down', 'did')" class="sorting"
                            >&#8595;</span
                            >
                        </th>
                        <th>
                            Created On
                            <span v-on:click="sorting('up', 'created_on')" class="sorting"
                            >&#8593;</span
                            >
                            <span v-on:click="sorting('down', 'created_on')" class="sorting"
                            >&#8595;</span
                            >
                        </th>
                        <th>Created By</th>
                        <th class="equal-th">Vendor</th>
                        <th class="equal-th client">Client</th>
                        <th class="equal-th">Country</th>
                        <th class="equal-th">DID type</th>
                        <th>State</th>
                        <th>Lata</th>
                        <th class="icon">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="add-row" v-if="is_add">
                        <th>
                            <primary-input
                                    type="number"
                                    name="did"
                                    class="field full-size-field"
                                    v-model="did.did"
                                    v-validate="'required'"
                                    :class="{ input: true, 'is-danger': errors.has('did') }"
                                    placeholder="Enter did number"
                            />
                            <div class="help is-danger" v-if="errors.has('did')">
                                {{ errors.first("did") }}
                            </div>
                        </th>
                        <th colspan="2"></th>
                        <th>
                            <primary-select
                                    class="full-size-field"
                                    type="text"
                                    name="vendor"
                                    v-model="did.vendor_uuid"
                                    :class="{ input: true, 'is-danger': errors.has('vendor') }"
                                    placeholder="Select Vendor"
                            >
                                <option
                                        v-for="item in vendors"
                                        :key="item.value"
                                        :value="item.value"
                                >
                                    {{ item.name }}
                                </option>
                            </primary-select>
<!--                            <div class="help is-danger" v-if="errors.has('vendor')">-->
<!--                                {{ errors.first("vendor") }}-->
<!--                            </div>-->
                        </th>
                        <th class="equal-th client">
                            <primary-select
                                    class="full-size-field input"
                                    type="text"
                                    name="company"
                                    v-model="did.company_uuid"
                                    placeholder="Select Client"
                            >
                                <option
                                        v-for="item in comapnies"
                                        :key="item.value"
                                        :value="item.value"
                                >
                                    {{ item.name }}
                                </option>
                            </primary-select>
                        </th>
                        <th>
                            <primary-select
                                    type="text"
                                    class="full-size-field"
                                    name="country"
                                    v-validate="'required'"
                                    v-model="did.country_uuid"
                                    :class="{ input: true, 'is-danger': errors.has('country') }"
                                    placeholder="Select Country"
                            >
                                <option
                                        :value="i.country_uuid"
                                        v-for="(i, index) in countries"
                                        :key="index"
                                >
                                    {{ i.nice_name }}
                                </option>
                            </primary-select>
                            <div class="help is-danger" v-if="errors.has('country')">
                                {{ errors.first("country") }}
                            </div>
                        </th>

                        <th>
                            <primary-select
                                    type="text"
                                    class="full-size-field"
                                    name="did type"
                                    v-validate="'required'"
                                    v-model="did.did_type"
                                    :class="{ input: true, 'is-danger': errors.has('did type') }"
                                    placeholder="Select DID Type"
                            >
                                <option
                                        v-for="item in didType"
                                        :key="item.value"
                                        :value="item.value"
                                >
                                    {{ item.name }}
                                </option>
                            </primary-select>
                            <div class="help is-danger" v-if="errors.has('did type')">
                                {{ errors.first("did type") }}
                            </div>
                        </th>

                        <th></th>
                        <th>
                            <div>
                                <secondary-button @click.native="cencel()" class="cencel"
                                >Cancel
                                </secondary-button
                                >
                            </div>
                        </th>
                    </tr>
                    <tr v-for="(did, k) in dids" :key="k">
                        <th class="equal-th editable">
                            <img
                                    v-if="did.active"
                                    class="number-icon"
                                    @click="isActive(did, true)"
                                    src="@/assets/Icon/Check/Active.svg"
                                    alt
                            />
                            <img
                                    v-if="!did.active"
                                    class="number-icon"
                                    @click="isActive(did, false)"
                                    src="@/assets/Icon/Check/Default.svg"
                                    alt
                            />
                            <primary-input
                                    :value="did.number"
                                    :disabled="!did.is_edit"
                                    @input="editing_did.did = $event"
                            />
                            <!-- <input type="text" :value="did.number" :disabled="!did.is_edit"> -->
                        </th>
                        <th>{{ did.createdOn }}</th>
                        <th>{{ did.createdBy }}</th>
                        <th class="equal-th editable">
                            <primary-select
                                    :is-cross="false"
                                    type="text"
                                    :options="vendors"
                                    :value="did.vendor_uuid"
                                    @input="editing_did.vendor_uuid = $event"
                                    :class="{'disabled': !did.is_edit}"
                                    :disabled="!did.is_edit"
                            />
                        </th>
                        <th class="equal-th client editable">
                            <primary-select
                                    :is-cross="false"
                                    type="text"
                                    :options="comapnies"
                                    :value="did.company_uuid"
                                    @input="editing_did.company_uuid = $event"
                                    :class="{'disabled': !did.is_edit}"
                                    :disabled="!did.is_edit"
                            />
                        </th>
                        <th class="equal-th">{{ did.countryName }}</th>
                        <th class="equal-th editable">
                            <primary-select
                                    :is-cross="false"
                                    type="text"
                                    :value="did.didType"
                                    @input="editing_did.did_type = $event"
                                    :class="{'disabled': !did.is_edit}"
                                    :options="didType"
                                    :disabled="!did.is_edit"
                            />
                        </th>
                        <th>{{ did.state }}</th>
                        <th>{{ did.lata }}</th>
                        <!--                <th><primary-button class="callflow" @click.native="$router.push({name: 'system-admin-dids-new-call-flow'})">New Callflow</primary-button></th>-->
                        <th class="icons d-flex align-items-center justify-content-center">
                            <div
                                    v-if="did.is_edit"
                                    @click="EditingDid(!did.is_edit, did.number)"
                                    class="mr-2 icon"
                                    title="Save"
                            >
                                <save-icon size="1.8x" class="custom-class"></save-icon>
                            </div>
                            <div
                                    v-if="did.is_edit"
                                    @click="did.is_edit = false"
                                    class="icon"
                                    title="Cancel"
                            >
                                <x-circle-icon size="1.8x" class="custom-class"></x-circle-icon>
                            </div>

                            <div v-else title="Edit">
                                <svg

                                        @click="EditingDid(!did.is_edit, did.number)"
                                        class="svg-grey"
                                        width="30px"
                                        height="30px"
                                        viewBox="0 0 30 30"
                                        version="1.1"
                                >
                                    <path
                                            d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                                            id="path-1"
                                    ></path>
                                </svg>
                            </div>
                        </th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div :style="{ display: paginationCondition ? 'flex' : 'block' }">
                <div class="per-page">
                    <span class="filter_by custom-row">Show Per Page:</span>
                    <div class="primary-input-container choose-type perPage">
                        <primary-select
                                type="text"
                                @input="changePerPage"
                                v-model="per_page" :is-cross="false"
                                class="choose-type perPage"
                                placeholder="Select"
                        >
                            <option :value="item" v-for="(item, key) in pages" :key="key">
                                {{ item }}
                            </option>
                        </primary-select>
                    </div>
                </div>
                <div
                        class="buttons-wrapper pgn-box"
                        v-if="dids.length"
                        :class="{ pagination: paginationCondition }"
                >
                    <pagination-component
                            @change-page="changePage($event)"
                            :page="Page"
                            :total="TotalPages"
                            :perPage="per_page"
                            :qnt="dids.length"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import {format} from "date-fns";
    import { XCircleIcon, SaveIcon  } from 'vue-feather-icons'

    export default {
        components: {
            SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            PaginationComponent: () => import("@/components/Pagination.vue"),
            PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            Loader: () => import("@/components/Loader.vue"),
            XCircleIcon,
            SaveIcon
        },
        data: () => ({
            dids: [],
            did: {
                did: null,
                company_uuid: null,
                vendor_uuid: null,
                did_type: null,
                country_uuid: null,
            },
            didType: [
                {name: "ANI", value: "ANI"},
                {name: "DNIS", value: "DNIS"}
            ],
            comapnies: [],
            vendors: [],
            is_add: false,
            Page: 0,
            SearchDid: "",
            SearchCompany: "",
            SearchVendor: "",
            PerPage: null,
            Total: null,
            TotalPages: null,
            active: null,
            isAllActive: false,
            selectedDids: [],
            loading: false,
            pages: [10, 50, 100],
            per_page: 10,
            is_adding: true,
            isDisabled: true,
            timeout: null,
            editing_did: {
                did_type: null,
                did: null,
                vendor_uuid: null,
                company_uuid: null
            }
        }),
        computed: {
            paginationCondition() {
                return this.dids.length < this.per_page && this.Page === 0;
            },
        },
        watch: {
            SearchDid: function () {
                this.waitingForType();
            },
            SearchCompany: function () {
                this.waitingForType();
            },
            SearchVendor: function (e) {
                this.waitingForType();
            },
            selectedDids: function (selected) {
                if (selected.length) {
                    this.isDisabled = false;
                } else {
                    this.isDisabled = true;
                }
            },
        },
        created() {
            this.getCountryList();
            this.getVendorList();
            this.getCompanyList();
            this.GetList();
        },
        methods: {
            EditingDid(is_edit, number) {
                let finded_did;
                this.dids.forEach(did => {
                    if (did.number === number) {
                        finded_did = did
                        did.is_edit = is_edit
                    } else {
                        did.is_edit = false
                    }
                })

                if (is_edit) {
                    // Editing ============================================================
                    this.editing_did.did = finded_did.number
                    this.editing_did.did_type = finded_did.didType
                    this.editing_did.vendor_uuid = finded_did.vendor_uuid
                    this.editing_did.company_uuid = finded_did.company_uuid

                } else {
                    // Call API ===========================================================
                    this.loading = true
                    this.$store.dispatch("EditDid", {
                        did: number,
                        newDid: this.editing_did,
                    })
                        .then((res) => {
                            this.GetList()
                            this.$snotify.success("DID have beed edited.", {
                                timeout: 6000,
                            });
                            this.loading = false
                        })
                        .catch((err) => {
                            if (err.errors) {
                                this.contactError = err.errors[0].contact
                                    ? err.errors[0].contact
                                    : null;
                                setTimeout(() => {
                                    this.contactError = null;
                                }, 6000);
                            } else {
                                this.$snotify.error(err.error.message, {
                                    timeout: 6000,
                                });
                            }
                        });
                }
            },
            waitingForType() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.beforeRequest();
                    this.GetList();
                }, 800);
            },
            beforeRequest() {
                if (!this.per_page) {
                    this.per_page = 10;
                }
                this.Page = 0;
            },
            cencel() {
                this.is_add = false;
                this.is_adding = true;
            },
            changePerPage(e) {
                this.is_add = false;
                this.per_page = e;
                this.Page = 0;
                this.GetList();
            },
            isActive(did, isAdding) {
                if (!isAdding) {
                    this.selectedDids.push(did.number);
                } else {
                    const getIndex = this.selectedDids.indexOf(did.number);
                    this.selectedDids.splice(getIndex, 1);
                }
                this.active = !this.active;
                this.dids.map((item) => {
                    if (item == did) {
                        did.active = !did.active;
                    }
                });
            },
            allActive(isAdding) {
                this.isAllActive = !this.isAllActive;
                this.dids.map((item) => {
                    if (isAdding) {
                        this.selectedDids = [];
                    } else {
                        this.selectedDids.push(item);
                    }
                    item.active = this.isAllActive;
                });
            },
            changePage(page) {
                this.Page = page;
                this.GetList();
            },
            sorting(type, sortBy) {
                let order_dir = "";
                if (type === "up") {
                    order_dir = "desc";
                } else {
                    order_dir = "asc";
                }

                this.GetList(order_dir, sortBy);
            },
            GetList(order_dir = "desc", sortBy = "created_on") {
                this.loading = true;
                this.$store
                    .dispatch("GetDids", {
                        did: this.SearchDid,
                        company_name: this.SearchCompany,
                        vendor_name: this.SearchVendor,
                        page: this.Page,
                        per_page: this.per_page ? this.per_page : 10,
                        order_by: sortBy,
                        order_dir: order_dir,
                    })
                    .then((res) => {
                        this.dids = res.items.map(this.transformDids);
                        this.loading = false;
                        this.per_page = res.per_page;
                        this.Total = res.total;
                        this.TotalPages = res.total / res.per_page;
                        this.selectedDids = [];
                        this.isAllActive = false;
                    });
            },
            transformDids(i, k) {
                return {
                    number: i.did,
                    createdBy: i.created_by,
                    countryName: i.iso3, // i.area ? i.area.country.iso3 :,
                    createdOn: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
                    assignedTo: i.company_name,
                    lata: i.lata,
                    state: i.state,
                    type: i.type,
                    active: false,
                    is_edit: false,
                    didType: i.did_type,
                    vendor_name: i.vendor_name,
                    company_name: i.company_name,
                    vendor_uuid: i.vendor_uuid,
                    company_uuid: i.company_uuid
                };
            },
            transformData(item) {
                return {
                    name: item.vendor_name,
                    value: item.vendor_uuid,
                };
            },
            transformCompany(item) {
                return {
                    name: item.company_name,
                    value: item.company_uuid
                }
            },
            getCountryName(id) {
                this.$store.dispatch("UserGetCountry", id).then((res) => {
                    return res.nice_name;
                });
            },
            getCountryList() {
                this.$store.dispatch("getCountryList", {}).then((res) => {
                    this.countries = res.items;
                });
            },
            getVendorList() {
                this.$store.dispatch("GetVendorList", {}).then((res) => {
                    this.vendors = res.items.map(this.transformData);
                });
            },
            getCompanyList() {
                this.loading = true;
                this.$store.dispatch("GetCompanyList", {}).then((res) => {
                    let {total} = res;
                    this.$store
                        .dispatch("GetCompanyList", {perPage: total})
                        .then((res) => {
                            this.comapnies = res.items.map(this.transformCompany);
                            this.loading = false;
                        });
                });
            },
            addDid() {
                this.is_adding = false
                if (!this.per_page) {
                    this.is_add = true;
                    this.per_page = 10;
                    this.GetList();
                    return;
                }
                if (!this.is_add) {
                    this.is_add = true;
                    return;
                } else {
                    this.$validator.validate().then((result) => {
                        if (result) {
                            if (!this.did.company_uuid) {
                                delete this.did.company_uuid;
                            }
                            this.$store
                                .dispatch("AddDid", {
                                    did: this.did,
                                })
                                .then(() => {
                                    (this.did = {
                                        did: null,
                                        company_uuid: null,
                                        did_type: null,
                                        country_uuid: null,
                                    }),
                                        (this.is_add = false);
                                    this.GetList();
                                    this.$success("DID have been added.");
                                    this.is_adding = true
                                })
                                .catch((err) => {
                                    this.is_add = true;
                                    this.$error(err);
                                });
                        }
                    });
                }
            },
            deleteSelected() {
                if (this.selectedDids.length == 0) {
                    return;
                }
                this.$swal({
                    title: "Are you sure?",
                    text: "You will not be able to recover this DIDs!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, keep it",
                }).then((result) => {
                    if (result.value) {
                        this.$store
                            .dispatch("DeleteSelectedDids", this.selectedDids)
                            .then((res) => {
                                this.GetList();
                                this.$swal({
                                    title: "Deleted!",
                                    text: "The DID has been deleted.",
                                    type: "success",
                                });
                            });
                    }
                });
            },
        },
    };
</script>
<style scoped lang="scss">
    tbody th {
        .primary-input-container {
            padding-right: 10px;
            margin: 20px 0 20px 0;

            .pimary-input-title {
                display: none !important;
            }

            .primary-input {
                padding-right: 10px;
            }
        }
    }

    table.Invoice_table {
        .editable {
            .primary-input-container {
                margin: 0;

                input {
                    text-align: center;
                    padding-left: 0;

                    &:disabled {
                        border: none;
                        background: #fff;
                        color: #212b36;
                    }
                }

                select {
                    text-align-last: center;

                    &:disabled {
                        color: #212b36;
                        opacity: 1;
                    }
                }

                &.disabled {
                    .primary-select-wrapper {
                        border: none;

                        select {
                            text-align: center;
                            color: #212b36;
                        }

                        img {
                            display: none;
                        }
                    }
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    tbody tr.add-row th {
        padding: 0 15px;

        &:first-child {
            display: block;
        }
    }

    .equal-th {
        width: 220px;

        &.client {
            padding-left: 0;
            padding-right: 0;
        }
    }

    .full-size-field {
        width: 100%;
        padding-right: 0;
    }

    .sorting {
        font-size: 18px;
        cursor: pointer;
    }

    .did-container {
        width: 100%;

        .per-page {
            display: flex;
            align-items: center;
            margin-top: 20px;
            margin-bottom: 20px;
            padding: 0;
        }

        .perPage {
            width: 120px;
        }

        .buttons-wrapper {
            display: flex;
            align-items: center;
            width: fit-content;
        }

        .pgn-box {
            width: 100%;
        }
    }

    .search-container {
        margin-top: 16px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .search-input {
            height: 36px;
            width: 200px;
            background-color: #ffffff;
            margin-right: 15px;
        }

        .buttons-wrapper {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: fit-content;
            width: 100%;
            margin-top: 0;

            &.pagination {
                width: fit-content;
                flex-grow: 1;
            }

            .secondary-button.importDid {
                height: 40px;
                width: 140px;
            }

            .secondary-button.addDid {
                height: 40px;
                width: 120px;
            }

            .secondary-button.deleteAll {
                height: 40px;
                width: 140px;
            }

            .secondary-button.deleteSelected {
                height: 40px;
                width: 160px;
            }
        }
    }

    table.Invoice_table {
        width: 100%;

        th {
            text-align: center;
            position: relative;
        }

        .save-btn {
            width: 100px;
            margin: 0 auto;
        }
    }

    table thead tr {
        background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
    }

    table thead th:first-child {
        padding-left: 20px;
        // padding-right: 30px;
        width: 14%;
    }

    table,
    tr {
        width: 100%;
        height: 44px;
        box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        background-color: #ffffff;
    }

    table {
        border-collapse: collapse;
    }

    .Invoice_table_header th {
        color: white;
        padding-left: 10px;
        border-bottom-width: 2px;
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        text-align: center;
    }

    .Invoice_table_header th:first-child {
        padding-left: 20px;
    }

    tbody th:first-child {
        display: flex;
        align-items: center;
        padding-left: 20px;
        padding-right: 10px;
    }

    tbody th {
        color: #212b36;
        font-weight: normal;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 20px;
        padding: 15px 10px;
    }

    tbody {
        .img-container {
            padding: 7px 0;
        }
    }

    th .secondary-button {
        height: 40px;
        width: 90px;
        //margin-bottom: 0;
    }

    th .svg-grey {
        cursor: pointer;
        fill: #55616e;
    }

    th .callflow {
        font-size: 12px;
        width: 110px;
        height: 20px;
        padding-top: 0px;
        float: right;
        line-height: 20px;
    }

    th .number-icon {
        height: 16px;
        width: 16px;
        margin-right: 10px;
        float: left;
    }

    .search-container > div {
        width: 100%;
        display: flex;
    }

    .custom-row {
        margin-right: 10px;
    }

    .no-data-found {
        padding: 20px;
        text-align: center;
        font-size: 20px;
        color: #e2e5ea;
        background-color: #fff;
    }

    @media (max-width: 1950px) {
        table.Invoice_table {
            width: 1850px;
        }
    }

    @media screen and (max-width: 1590px) {
        .search-container {
            flex-direction: column;
        }
    }

    .table_div::-webkit-scrollbar {
        // width: 5px;
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table_div::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.44, #51a3f3),
                        color-stop(0.72, #51a3f3),
                        color-stop(0.86, #51a3f3)
        );
    }

    @media (min-width: 577px) {
        .w-sm-auto {
            width: auto !important;
        }
    }
    .icons .icon {
        cursor: pointer;
        transition: .2s;

        &:hover {
            transform: scale(1.2);
            transition: .2s;
        }
    }
    .filter_by {
        white-space: nowrap;
    }

    .input-button-margin-size{
      margin-bottom: 16px;
    }

    .help {
        position: absolute;
        bottom: 2px;
    }

    .field + .help {
        bottom: -18px;
    }
</style>

